import { useContext } from 'react';
import ProjectProgressionContext from '../state/context';
import { ProjectProgressionFiltersContext } from '../../../state/filters/contexts';
import ProjectsFiltersBar from '../../../state/filters/components/ProjectsFiltersBar';
import LastUpdatedAt from './LastUpdatedAt';
import {
  PERIODS,
  PERIODS_LAST_X_QUARTERS
} from 'components/PeriodPicker/periods/constants';
import { getLastXQuartersPeriods } from 'components/PeriodPicker/periods/utils';

const Header = () => {
  const {
    state: { loadingMap }
  } = useContext(ProjectProgressionContext);

  const isPeriodPickerDisabled = Object.values(loadingMap).some(Boolean);

  return (
    <ProjectsFiltersBar
      Context={ProjectProgressionFiltersContext}
      disabled={isPeriodPickerDisabled}
      hiddenPeriods={[
        PERIODS.CUSTOM,
        ...getLastXQuartersPeriods(PERIODS_LAST_X_QUARTERS)
      ]}
    >
      <LastUpdatedAt />
    </ProjectsFiltersBar>
  );
};

export default Header;
